import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'marketplace step title',
    defaultMessage: 'Connect a store <span>{emoji}</span>',
    id: 'G6eVp0',
  },
  description: {
    description: 'markplace step description',
    defaultMessage: 'Connect to an unlimited number of stores. We bring all of your orders together for simplified order management.',
    id: 'sfEUuu',
  },
  addMessage: {
    description: 'marketplace step add message',
    defaultMessage: 'Connect a Store',
    id: 'r/xVs0',
  },
  manualStoreOrCSVImport: {
    description: 'contains a button to add manual orders and a button to import CSVs',
    defaultMessage: '<button1>Add a manual order</button1> | <button2>Import CSV</button2> | <button3>Manage stores</button3>',
    id: 'iAxAyL',
  },
  manualCSV: {
    description: 'contains a button to add manual orders and a button to import CSVs',
    defaultMessage: "Don't have a store? <button1>Add an order</button1> or <button2>import CSV.</button2>",
    id: 'Lq5AIu',
  },
  rateBrowser: {
    description: 'contains a button open the rate browser',
    defaultMessage: 'You can also <button>create a single label</button>.',
    id: 'MvTCEw',
  },
  addAnotherMessage: {
    description: 'marketplace step add another message',
    defaultMessage: 'Add a store',
    id: 'aH6cD8',
  },
  connectedMarketplaceMessage: {
    description: 'connected marketplace message with update time',
    defaultMessage: 'Connected {bullet} Updated: {date} {time}',
    id: 'xTFfCy',
  },
  connected: {
    description: 'connected marketplace message',
    defaultMessage: 'Connected',
    id: 'V5+NSA',
  },
  saveSuccessTitle: {
    description: 'marketplace step marketplace growler success title',
    defaultMessage: 'Great job. Store connected!',
    id: 'pCrQXq',
  },
  saveSuccessMessage: {
    description: 'marketplace step marketplace growler success message',
    defaultMessage: 'ShipStation has started importing your orders. Go to the <a>Orders</a> screen to view them and start shipping.',
    id: 'cKSY6I',
  },
  controlSaveSuccessMessage: {
    description: 'marketplace step marketplace growler success message',
    defaultMessage: 'Marketplace connected!',
    id: 'Nzsccs',
  },
  viewMore: {
    description: 'view more marketplaces link message',
    defaultMessage: 'View More...',
    id: 'KtKluj',
  },
  mobileConnectionSuccess: {
    description: 'banner message for mobile user that a store was connected',
    defaultMessage: 'Store connected. Import in progress',
    id: 'kYpSRj',
  },
});

export default messages;
